import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    CircularProgress,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import {
    useAiRegenerateCallSummary,
    useAiRegenerateCallTranscript,
} from '../../../sic-lib/api/hooks/useAi';
import { ChannelItemCall } from '../../../sic-lib/types/ChannelItem';

interface Props {
    channelItem: ChannelItemCall;
}

export default function DevtoolsMenu({ channelItem }: Props) {
    const { classes } = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpenMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const {
        refetch: refetchSummary,
        isFetching: isFetchingCallSummary,
        isError: isErrorCallSummary,
        isSuccess: isSuccessCallSummary,
    } = useAiRegenerateCallSummary({
        contactId: channelItem?.contactId!,
        channelType: channelItem?.type!,
        channelIndexId: channelItem?.id,
    });

    const {
        refetch: refetchTranscript,
        isFetching: isFetchingTranscript,
        isError: isErrorTranscript,
        isSuccess: isSuccessTranscript,
    } = useAiRegenerateCallTranscript({
        contactId: channelItem?.contactId!,
        channelType: channelItem?.type!,
        channelIndexId: channelItem?.id,
    });

    const handleRegenerateTranscript = () => {
        refetchTranscript();
    };

    const handleRegenerateCallSummary = () => {
        refetchSummary();
    };

    return (
        <>
            <IconButton onClick={handleOpenMenuClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu id="call-dev-tools-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={handleRegenerateTranscript}>
                    {isFetchingTranscript && (
                        <ListItemIcon>
                            <CircularProgress size={16} />
                        </ListItemIcon>
                    )}
                    <ListItemText inset={!isFetchingTranscript}>Regenerate Transcript</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleRegenerateCallSummary}>
                    {isFetchingCallSummary && (
                        <ListItemIcon>
                            <CircularProgress size={16} />
                        </ListItemIcon>
                    )}
                    <ListItemText inset={!isFetchingCallSummary}>
                        Regenerate Call Summary
                    </ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
